import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import * as axios from 'axios';
import { conf } from '../confg';

const mediaUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = (conf.image_url || '').replace(/\/?$/, '/');
  return base + String(path).replace(/^\//, '');
};

/**
 * Shows trust_seals.items logos from api/site-info next to Enamad.
 * Click opens the license image when available.
 */
const UnionLicenseBadge = ({ className = '', imgStyle }) => {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios({ url: conf.server_url + 'site-info', method: 'GET' })
      .then((res) => {
        const seals = res?.data?.data?.trust_seals;
        const list = Array.isArray(seals?.items) ? seals.items : [];
        const withLogo = list.filter((item) => item?.logo);
        if (!cancelled) {
          if (withLogo.length) {
            setItems(withLogo);
            return;
          }
          // fallback برای ساختار قدیمی
          const ul = seals?.union_license;
          if (ul?.enabled && ul?.logo) {
            setItems([{ id: 'union_license', title: 'مجوز اتحادیه', ...ul }]);
          }
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!items.length) return null;

  return (
    <>
      {items.map((item) => {
        const logoSrc = mediaUrl(item.logo);
        const imageSrc = mediaUrl(item.image);
        if (!logoSrc) return null;

        const handleClick = (e) => {
          e.preventDefault();
          if (imageSrc) {
            setActive(item);
            return;
          }
          if (item.link) {
            window.open(item.link, '_blank', 'noopener,noreferrer');
          }
        };

        return (
          <button
            key={item.id || logoSrc}
            type='button'
            className={`union-license-badge ${className}`.trim()}
            onClick={handleClick}
            aria-label={item.title || 'مجوز'}
            style={{
              border: 0,
              background: 'transparent',
              padding: 0,
              cursor: 'pointer',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          >
            <img
              src={logoSrc}
              alt={item.title || 'مجوز'}
              style={{ cursor: 'pointer', maxHeight: 96, width: 'auto', ...imgStyle }}
            />
          </button>
        );
      })}

      <Modal show={Boolean(active)} onHide={() => setActive(null)} centered size='lg'>
        <Modal.Header closeButton>
          <Modal.Title className='c-font-md'>{active?.title || 'مجوز'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          {active?.image ? (
            <img src={mediaUrl(active.image)} alt={active.title || 'مجوز'} style={{ maxWidth: '100%', height: 'auto' }} />
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UnionLicenseBadge;
